import { useDiscussionListContext } from "@pathwright/web/src/modules/discussion/list/DiscussionListContainer"
import {
  DISCUSSION_CONTROL_FILTER_ALL,
  DISCUSSION_CONTROL_FILTER_DISCUSSION_QUESTIONS,
  DISCUSSION_CONTROL_FILTER_QUESTIONS,
  DISCUSSION_CONTROL_FILTER_UNANSWERED,
  DISCUSSION_CONTROL_SORT_BEST,
  DISCUSSION_CONTROL_SORT_MOST_ACTIVE,
  DISCUSSION_CONTROL_SORT_RECENTLY_ACTIVE,
  DISCUSSION_CONTROL_SORT_RECENTLY_CREATED,
  FILTERS,
  SORTS
} from "@pathwright/web/src/modules/discussion/list/utils"
import PropTypes from "prop-types"
import CommunityAreaFilter from "../CommunityAreaFilter"

const getControlFilterLabel = (filter, translator) => {
  switch (filter) {
    case DISCUSSION_CONTROL_FILTER_ALL:
      return {
        title: translator("Discussions")
      }
    case DISCUSSION_CONTROL_FILTER_UNANSWERED:
      return {
        title: translator("Unanswered discussions")
      }
    case DISCUSSION_CONTROL_FILTER_DISCUSSION_QUESTIONS:
      return {
        title: translator("Discussion prompts")
      }
    case DISCUSSION_CONTROL_FILTER_QUESTIONS:
      return {
        title: translator("Member discussions")
      }
  }
}

const getControlSortLabel = (sort, translator) => {
  switch (sort) {
    case DISCUSSION_CONTROL_SORT_RECENTLY_ACTIVE:
      return {
        title: translator("Recently active")
      }
    case DISCUSSION_CONTROL_SORT_RECENTLY_CREATED:
      return {
        title: translator("Recently posted")
      }
    case DISCUSSION_CONTROL_SORT_MOST_ACTIVE:
      return {
        title: translator("Most active")
      }
    case DISCUSSION_CONTROL_SORT_BEST:
      return {
        title: translator("Most liked")
      }
  }
}

// controlled component
const CommunityDiscussionFilter = ({ inverted, children }) => {
  const { filter, sort, onFilter, onSort } = useDiscussionListContext()
  return (
    <CommunityAreaFilter
      filter={filter}
      sort={sort}
      filters={FILTERS}
      sorts={SORTS}
      onFilter={onFilter}
      onSort={onSort}
      getControlFilterLabel={getControlFilterLabel}
      getControlSortLabel={getControlSortLabel}
      inverted={inverted}
      // Button props.
      size="medium"
    >
      {children}
    </CommunityAreaFilter>
  )
}

CommunityDiscussionFilter.displayName = "CommunityDiscussionFilter"

CommunityDiscussionFilter.propTypes = {
  inverted: PropTypes.bool
}

export default CommunityDiscussionFilter
